import { SuperConsultantHomePage } from 'pages/SuperConsultant/SuperConsultantHomepage';
import SuperConsultantProfile from 'pages/SuperConsultant/SuperConsultantProfile';
import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import Layout from './Layout';
import SuperConsultantOrdersOverdue from 'pages/SuperConsultant/SuperConsultantOrdersOverDue';
import SuperConsultantOrdersInProgress from 'pages/SuperConsultant/SuperConsultantOrdersInProgress';
import SuperConsultantFicheClient from 'pages/SuperConsultant/SuperConsultantFicheClient';
import SuperConsultantCampaignDetail from 'pages/SuperConsultant/SuperConsultantCampaignDetail';
import SuperConsultantCreateCampaign from 'pages/SuperConsultant/SuperConsultantCreateCampaign';
import SuperConsultantOrdersByWebsite from 'pages/SuperConsultant/SuperConsultantOrdersByWebsite';
import SuperConsultantUnassignedOrders from 'pages/SuperConsultant/SuperConsultantUnassignedOrders';
import SuperConsultantDraftOrders from 'pages/SuperConsultant/SuperConsultantDraftOrders';
import StillWorkingOnIt from './UnderConstruction';
import SuperConsultantOrdersOnline from 'pages/SuperConsultant/SuperConsultantOnlineOdrers';
import VueGlobale from 'pages/SuperAdmin/SuperAdminVueGlobale';
export default class SuperConsultantMainMenu extends React.Component {
  render() {
    return (
      <Layout>
        <Switch>
          <Route
            exact
            path="/SuperConsultant"
            component={SuperConsultantHomePage}
          />
          <Route
            path="/SuperConsultant/MainMenu"
            component={SuperConsultantHomePage}
          />
          <Route
            path="/SuperConsultant/MonProfil"
            component={SuperConsultantProfile}
          />
          <Route
            path="/SuperConsultant/CampagnesEnCour"
            component={SuperConsultantOrdersInProgress}
          />
          <Route
            path="/SuperConsultant/CampagnesNonAttribuees"
            component={SuperConsultantUnassignedOrders}
          />
          <Route
            path="/SuperConsultant/CampagnesEnBrouillon"
            component={SuperConsultantDraftOrders}
          />
          <Route
            path="/SuperConsultant/CampagnesEnRetard"
            component={SuperConsultantOrdersOverdue}
          />
          <Route
            path="/SuperConsultant/FicheClient/:id"
            component={SuperConsultantFicheClient}
          ></Route>
          <Route
            path="/SuperConsultant/FicheClient/:id"
            component={SuperConsultantFicheClient}
          ></Route>
          <Route
            path="/SuperConsultant/DetailsCampagne/:id"
            component={SuperConsultantCampaignDetail}
          />
          <Route
            path="/superConsultant/AjouterCampaign"
            component={SuperConsultantCreateCampaign}
          />
          <Route
            path="/SuperConsultant/Website/:id/Campagnes"
            component={SuperConsultantOrdersByWebsite}
          ></Route>
          <Route
            path="/SuperConsultant/CampagnesEnLigne"
            component={SuperConsultantOrdersOnline}
          ></Route>
          <Route
            path="/SuperConsultant/VueGlobale"
            component={VueGlobale}
          ></Route>
        </Switch>
        <></>
      </Layout>
    );
  }
}
